import { useEffect, useRef } from 'react';

/**
 * Adds 'animate-slide-up' class to elements with data-reveal attribute
 * when they scroll into view. Use on a container element.
 */
export function useScrollReveal() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const elements = container.querySelectorAll('[data-reveal]');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-slide-up');
            entry.target.classList.remove('opacity-0', 'translate-y-4');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    elements.forEach((el) => {
      el.classList.add('opacity-0', 'translate-y-4');
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return containerRef;
}
